import React from 'react';
import * as Styled from '../../carousel-lite.styled';
export var CurrentSlideInfo = function (_a) {
    var currentSlideIndex = _a.currentSlideIndex, isMobileAndUsesCSSScrollSnapOnly = _a.isMobileAndUsesCSSScrollSnapOnly, showCurrentSlideInfo = _a.showCurrentSlideInfo, totalSlides = _a.totalSlides;
    if (!showCurrentSlideInfo || isMobileAndUsesCSSScrollSnapOnly)
        return null;
    return React.createElement(Styled.CurrentSlideInfo, null, "".concat(currentSlideIndex + 1, " of ").concat(totalSlides));
};
